export default "__VITE_ASSET__o1kfETrM__"